export const E_VOUCHER_CODE_LENGTH = 16;

const E_VOUCHER_ERROR_MESSAGES: Record<string, string> = {
  e_voucher_not_found: 'This e-voucher code is invalid. Please check the code and try again.',
  e_voucher_deactivated: 'This e-voucher has been deactivated and can no longer be redeemed.',
  e_voucher_already_redeemed: 'This e-voucher has already been redeemed.',
  e_voucher_expired: 'This e-voucher has expired.',
};

const DEFAULT_E_VOUCHER_ERROR = 'Something went wrong. Please try again.';

export const normalizeEVoucherCode = (value: string): string =>
  value
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase()
    .slice(0, E_VOUCHER_CODE_LENGTH);

export const formatEVoucherCode = (code: string): string => code.match(/.{1,4}/g)?.join(' ') ?? '';

export const getEVoucherErrorMessage = (error: unknown): string => {
  const code = error instanceof Error ? error.message : '';
  return E_VOUCHER_ERROR_MESSAGES[code] ?? DEFAULT_E_VOUCHER_ERROR;
};
